import React from 'react';
import PropTypes from 'prop-types';
import style from './style.module.less';

export const SearchResult = ({ itemName = '', itemSku = '' }) => {
  return (
    <div>
      <div className={style['item-name']}>{itemName}</div>
      <div className={style['item-sku']}>{itemSku}</div>
    </div>
  );
};

SearchResult.propTypes = {
  itemName: PropTypes.string,
  itemSku: PropTypes.string,
};
